import type { AppProps } from 'next/app';
import { Component, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import AppContext from '../AppContext';
import { persistTrackingParams } from '../utilities/tracking';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '../styles/globals.css';

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const [appState, setAppState] = useState({
    quoteRequestData: {},
    quoteData: {},
    quoteModalOpen: false,
    importModalOpen: false,
    importInfoModalOpen: false,
    compareModalOpen: false,
    detailsModalOpen: false,
    initialLoadFromLocal: false,
    loadingQuoteResult: false,
    quoteRequestError: false,
    selectedTab: 0
  });

  useEffect(() => {
    if (router.isReady) persistTrackingParams(router.query);
  }, [router.isReady, router.query]);

  useEffect(() => {
    if (localStorage.getItem('quote-form')) {
      const quoteDataRaw = localStorage.getItem('quote');
      setAppState({
        ...appState,
        quoteRequestData: JSON.parse(localStorage.getItem('quote-form') as string),
        initialLoadFromLocal: true,
        quoteData: quoteDataRaw? JSON.parse(quoteDataRaw):{}
      });
      // Fired by writes from another tab, which happen on every keystroke. Built
      // from the state captured at load, it used to reset this tab and drop the
      // quote being bought; it now changes only what the other tab changed.
      window.addEventListener('storage', (event) => {
        if (event.key !== 'quote-form' || !event.newValue) return;

        setAppState((current: typeof appState) => ({
          ...current,
          quoteRequestData: JSON.parse(event.newValue as string),
          initialLoadFromLocal: false
        }));
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
    <AppContext.Provider
      value={{
        state: appState,
        setAppState: setAppState
      }}
    >
      <Component {...pageProps} />
      </AppContext.Provider>
      </>
  );
}

export default MyApp